// Magnify.js
import { getPCSelectionResumeAction } from './pcSelection.js';
import DragBox from 'ol/interaction/DragBox';
import { always } from 'ol/events/condition';
import { getMap } from './mapInstance.js';
import { setMapCursor } from './mapUtils.js';
import { setActiveSidebarTool, setSidebarToolActive } from './dialogs.js';
import { resetActiveCommandsOnly } from './resetApplication.js';

let zoomBoxInteraction = null;

/**
 * Toggle Zoom by Window (DragBox)
 */
export function toggleDragZoom() {

  const map = getMap();
  if (!map) return;

  if (zoomBoxInteraction) {
    map.removeInteraction(zoomBoxInteraction);
    zoomBoxInteraction = null;
    setMapCursor('default');
    setSidebarToolActive('.zoom-box-button', false);
    //console.log("Zoom by Window OFF");
    return;
  }

  const resumeSelection = getPCSelectionResumeAction();
  resetActiveCommandsOnly();
  zoomBoxInteraction = new DragBox({ condition: always });

  zoomBoxInteraction.on('boxend', () => {
    const extent = zoomBoxInteraction.getGeometry().getExtent();
    map.getView().fit(extent, { duration: 400, callback: () => {
      if (!resumeSelection) return;
      deactivateDragZoom();
      resumeSelection();
    } });
  });

  map.addInteraction(zoomBoxInteraction);
  setMapCursor('crosshair');
  setActiveSidebarTool('.zoom-box-button', { lock: true });

  //console.log("Zoom by Window ON");
}

export function deactivateDragZoom() {
  const map = getMap();
  if (!map || !zoomBoxInteraction) return;

  map.removeInteraction(zoomBoxInteraction);
  zoomBoxInteraction = null;
  setMapCursor('default');
  setSidebarToolActive('.zoom-box-button', false);
}

export function isDragZoomActive() {
  return !!zoomBoxInteraction;
}

document.addEventListener('application-reset-active-tools', () => {
  deactivateDragZoom();
});
